module.exports = __webpack_public_path__ + "static/media/634.84c94c73.webp";